<template>
  <div>
    <el-dialog :title="title" :visible.sync="dialogVisible" append-to-body>
      <span slot="footer" class="dialog-footer">
       
        <el-button type="primary" @click="goNext" style="backgroundColor:#FFFFFF;color: #000; border:none;border-radius: 12px;">确 定</el-button>
        <el-button @click="dialogVisible = false" style="border: 1px solid #404040;background: #1A1A1A;border-radius: 12px;color: #DFDFDF;">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'ConfirmDialog',
  props: ['title'],
  data() {
    return {
      dialogVisible: false
    }
  },
  methods: {
    showDialog() {
      this.dialogVisible = true
    },
    goNext() {
      this.dialogVisible = false
      this.$emit('reLoad')
    }
  }
}
</script>
<style lang="scss" scoped>
/deep/ .el-dialog__title{
  color:#ffffff !important;
  font-family: Source Han Sans SC;
  font-weight: 400;
  font-size: 18px;
  
}
/deep/ .el-dialog {
  width: 480px !important;
  height: initial !important;
   background: #1A1A1A !important;
    border-radius: 8px;
    border: 1px solid #545454;
  .el-dialog__body {
    padding: 0 40px;
  }
  .el-dialog__header {
    text-align: center;

    padding: 40px 40px 0 40px !important;
    border-radius: 8px 8px 0 0;
  }
  .el-dialog__headerbtn {
    top: 40px;
    right: 40px;
  }
  .el-dialog__footer {
  
    text-align: center;
    padding: 40px;
    border-radius: 0px 0px 8px 8px;
  }
  .el-button + .el-button {
    margin-left: 25px;
  }
  .el-button {
    width: 74px;
    height: 24px;
    padding: 5px 23px;
  }
}
</style>
